import { useTranslation } from "react-i18next";
import { useState } from "react";
import dayjs from "dayjs";
import { FilterOutlined, PlusOutlined, RedoOutlined } from "@ant-design/icons";
import { Flex, Row, Select, Space, Button, Card } from "antd";
import EmployeeWorkInLeaveBenefitTable from "components/table/EmployeeWorkInLeaveBenefitTable";
import ModalLeaveBenefit from "components/elements/Modal/ModalLeaveBenefit";
import { ReactComponent as FilterIcon } from "../../../assets/icon/filterIcon.svg";

import { FormDatePicker } from "components/form/FormProvide";
// import { DatePicker } from "components/form";
import { Form } from "formik";
import { DatePicker } from "antd/lib";
import EmployeeWorkInLeaveBenefitFilter from "./EmployeeWorkinLeaveBenefitFilter";
// import { DatePicker } from "components/form";

function EmployeeWorkInLeaveBenefit({
  pagination = {},
  isModalOpen = false,
  setIsModalOpen = () => { },
  isLoading = false,
  leaveBenefitList = [],
  onChange = () => { },
  onFilter = () => { },
  onCreate = () => { },
  onYearChange = () => { },
  modifiedLeaveGroupOptions = () => { },
  getCardInfo = () => { },
  currentMyRequest = {},
  onEdit = () => { },
  onSubmit = () => { },
  onSearch = () => { },
  onCalculate = () => { },
  onDelete = () => { },
  selectedYear = null,
  setYear = () => { },
  onToggleChange = () => { },
  onCancel = () => { }
}) {
  const { i18n, t } = useTranslation();


  const handleChange = (event) => {
    console.log('year : ', dayjs(event).year());

    setYear(dayjs(event).year());
    onYearChange(dayjs(event).year(), pagination)
  };

  const years = [];
  const currentYear = new Date().getFullYear();
  const [useFilter, setUseFilter] = useState(false);
  for (let year = 1900; year <= currentYear; year++) {
    years.push(year);
  }
  return (
    <>
      <ModalLeaveBenefit onSubmit={onSubmit} isModalOpen={isModalOpen} initailValue={currentMyRequest} leaveGroupOptions={modifiedLeaveGroupOptions} setIsModalOpen={setIsModalOpen} onCancel={onCancel} />
      <Space style={{ width: "100%" }} size={24} direction="vertical">
        <Flex vertical={useFilter} justify="end" align="flex-end" gap={12}>
          {/* <DatePicker
              name="year"
              dateFormat={"YYYY"}
              picker="year"
              label={t('leave-rights')}
              allowClear
              placeholder={t('report.all')}
              onChange={handleChange}
            // defaultValue={moment('2023', 'YYYY')} // แสดงปี 2023 เป็นค่าเริ่มต้น
            /> */}
          <Button type="default" onClick={() => setUseFilter(!useFilter)}
            style={{ height: "40px", borderRadius: "8px" }}
          >
            <Flex align="center" justify="center" gap={8}>
              <FilterIcon />
              <span style={{ color: "#667085" }}>{t('common.filter')}</span>
            </Flex>
          </Button>

          {useFilter && (
            <Card style={{
              borderRadius: "8px",
              backgroundColor: "white",
              border: "1px solid #EAECF0",
              width: "100%"
            }}>
              <EmployeeWorkInLeaveBenefitFilter
                leaveGroupOptions={modifiedLeaveGroupOptions}
                onSearch={onSearch}
              />
            </Card>
          )}

          <Button
            onClick={onCalculate}
            type="primary"
            style={{ height: "40px", borderRadius: "8px", backgroundColor: "var(--button-color)" }}
            loading={isLoading}
          >
            <RedoOutlined /> {t("calculate")}
          </Button>
        </Flex>

        <EmployeeWorkInLeaveBenefitTable
          isLoading={isLoading}
          dataSource={leaveBenefitList}
          pagination={pagination}
          onChange={onChange}
          onEdit={onEdit}
          onDelete={onDelete}
          onToggleChange={onToggleChange}
        />
      </Space>
    </>
  );
}

export default EmployeeWorkInLeaveBenefit;
